var m = require('mithril');
var prop = require('mithril/stream');
var requestStatusHandler = require('./requestStatusHandler');
var RequestStatus = require('../enums/RequestStatus');

function statusCode(error) {
  var value = error && (error.status || error.statusCode || error.code || (error.response && error.response.status));
  var code = Number(value);
  return Number.isFinite(code) ? code : null;
}

function initialize(ctrl) {
  ctrl.pickerRequestStatus = prop(RequestStatus.PENDING);
  ctrl.pickerRequestStatusCode = prop(null);
  ctrl.retryPickerRequest = null;
}

function run(ctrl, request, options) {
  options = options || {};
  ctrl.pickerRequestStatus(RequestStatus.PENDING);
  ctrl.pickerRequestStatusCode(null);
  ctrl.retryPickerRequest = options.onRetry || request;

  return Promise.resolve()
    .then(request)
    .then(function (result) {
      ctrl.pickerRequestStatus(RequestStatus.SUCCESS);
      return result;
    })
    .catch(function (error) {
      // Pickers are commonly embedded in modals. A failed lookup must leave a
      // usable error and Retry action instead of an empty modal or a rejected
      // event-handler promise.
      console.error(options.errorMessage || 'Unable to load picker data:', error);
      ctrl.pickerRequestStatusCode(statusCode(error));
      ctrl.pickerRequestStatus(RequestStatus.ERROR);
      m.redraw();
      return null;
    });
}

function view(ctrl) {
  if (!ctrl.pickerRequestStatus || ctrl.pickerRequestStatus() === RequestStatus.SUCCESS) return null;
  return m(requestStatusHandler, {
    requestStatus: ctrl.pickerRequestStatus,
    requestStatusCode: ctrl.pickerRequestStatusCode,
    onRetry: ctrl.retryPickerRequest
  });
}

module.exports = {
  initialize: initialize,
  run: run,
  view: view,
  _test: {
    statusCode: statusCode
  }
};
